import React from 'react';
import { useMatch } from 'react-router-dom';

import StandingOrderContainer from '../../standingOrders/containers/StandingOrderContainer';
import StandingOrderItemContainer from '../../singleStandingOrder/containers/SingleStandingOrderContainer';
import PageContainer from 'components/shared/generic/pageContainer/presentational/PageContainer';

const MainContainer = () => {
    const match = useMatch('/payments/standing-order/:id');

    return (
        <PageContainer>
            {match ? (
                <StandingOrderItemContainer />
            ) : (
                <StandingOrderContainer />
            )}
        </PageContainer>
    );
};

export default MainContainer;
